import type { FC } from "react";
import { CheckIcon } from "lucide-react";
import { cn } from "@/ds/utils";

export interface SelectableOptionProps {
	media: React.ReactNode;
	title: React.ReactNode;
	subtitle?: React.ReactNode;
	selected: boolean;
	onSelect: () => void;
	disabled?: boolean;
}

export const SelectableOption: FC<SelectableOptionProps> = props => {
	const {
		media,
		title,
		subtitle,
		selected,
		onSelect,
		disabled = false
	} = props;

	return (
		<button
			type="button"
			role="radio"
			aria-checked={selected}
			disabled={disabled}
			onClick={onSelect}
			className={cn(
				"flex w-full cursor-pointer items-center gap-3 rounded-md border p-3 text-left transition-colors outline-none hover:bg-accent focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50",
				selected && "border-primary bg-primary/5 hover:bg-primary/10 dark:bg-primary/10"
			)}>
			{media}
			<div className="min-w-0 flex-1">
				<div className="truncate text-sm font-medium">{title}</div>
				{subtitle && <div className="truncate text-xs text-muted-foreground">{subtitle}</div>}
			</div>
			<div className={cn("flex size-4 shrink-0 items-center justify-center rounded-full border", selected && "border-primary bg-primary text-primary-foreground")}>
				{selected && <CheckIcon className="size-3" />}
			</div>
		</button>
	);
};
